<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>
              {{ source.name }}
            </h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Name *</label>
                  <div class="col-md-10">
                    <input
                      id="name"
                      v-model="entity.name"
                      type="text"
                      placeholder="Enter name"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">Email *</label>
                  <div class="col-md-10">
                    <input
                      id="email"
                      v-model="entity.email"
                      type="text"
                      placeholder="Enter email"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">New Password</label>
                  <div class="col-md-10">
                    <input
                      id="newPassword"
                      v-model="newPassword"
                      type="password"
                      placeholder="Enter password"
                      class="form-control"
                    >
                  </div>
                </div>

                <div v-if="newPassword" class="form-group row">
                  <label for="title" class="col-md-2">New Password Confirmation</label>
                  <div class="col-md-10">
                    <input
                      id="newPasswordConfirmation"
                      v-model="newPasswordConfirmation"
                      type="password"
                      placeholder="Enter password"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Roles</label>
                  <div class="col-md-10">
                    <vue-select
                      v-model="entity.roles"
                      multiple
                      :options="rolesList"
                      label="name"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Avatar</label>
                  <div class="col-md-10">
                    <image-uploader
                      :uploaded-img-url="avatarUrl"
                      @changeFile="changeAvatar"
                      @returnedOldFile="avatarRestore"
                      @existingFileRemoved="avatarRemove"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="saveEntity">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Data saved successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import VueSelect from 'vue-select';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';

export default {
  name: 'UsersEdit',

  components: {
    'vue-select': VueSelect,
  },

  mixins: [EditPageMixin],

  data() {
    return {
      source: null,
      entity: {},
      newPassword: null,
      newPasswordConfirmation: null,
    };
  },

  computed: {
    rolesList() {
      return this.$store.state.roles.list;
    },
    avatarUrl() {
      if (!this.source) return null;
      if (Object.prototype.hasOwnProperty.call(this.source, 'avatar') && this.source.avatar) {
        return this.source.avatar.public_url;
      }
      return null;
    },
    avatarIsChanged() {
      if (!this.source.avatar) {
        return !!this.entity.avatar;
      }
      if (_.isObject(this.entity.avatar) && this.entity.avatar.id === this.source.avatar.id) {
        return false;
      }
      return true;
    },
  },

  methods: {
    isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      if (!this.entity.email) {
        this.$_showError('Email field is required');
        return false;
      }
      if (this.newPassword && this.newPassword.length < 6) {
        this.$_showError('New password must be at least 6 characters');
        return false;
      }
      if (this.newPassword && !this.newPasswordConfirmation) {
        this.$_showError('Please confirm new password');
        return false;
      }
      if (!this.entity.roles.length) {
        this.$_showError('Roles field is required');
        return false;
      }
      return true;
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}users/${this.$route.params.id}?with[]=avatar&with[]=roles`)
        .then((response) => {
          this.source = response.data;
          this.entity = _.cloneDeep(response.data);
          if (!Object.prototype.hasOwnProperty.call(response.data, 'avatar')) {
            this.source.avatar = null;
            this.entity.avatar = null;
          }
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        }).catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting data request' });
          console.error(error);
        });
    },
    changeAvatar(file) {
      this.entity.avatar = file;
    },
    avatarRestore() {
      this.entity.avatar = this.source.avatar;
    },
    avatarRemove() {
      this.entity.avatar = null;
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      postFormData.append('email', this.entity.email);
      if (this.newPassword && this.newPasswordConfirmation) {
        postFormData.append('password', this.newPassword);
        postFormData.append('password_confirmation', this.newPasswordConfirmation);
      }
      if (this.entity.roles && this.entity.roles.length) {
        for (let i = 0; i < this.entity.roles.length; i += 1) {
          postFormData.append('roles[]', this.entity.roles[i].id);
        }
      }
      return this.$apiHttp.post(`${this.$config.app_api.prefix}users/${this.$route.params.id}`, postFormData);
    },
    saveAvatarRequest() {
      const postFormData = new FormData();
      postFormData.append('avatar', this.entity.avatar);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}users/${this.$route.params.id}/avatar`, postFormData);
    },
    deleteAvatarRequest() {
      return this.$apiHttp.delete(`${this.$config.app_api.prefix}users/${this.$route.params.id}/avatar`);
    },
    saveEntity() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (!this.avatarIsChanged) {
        this.saveRequest().then(() => {
          this.$_successSave();
        }).catch((error) => {
          this.$_errorSave(error);
          console.error('Error in update user query', error);
        });
      } else if (!this.entity.avatar) {
        axios.all([this.deleteAvatarRequest(), this.saveRequest()]).then(axios.spread((avatar, entity) => {
          if (Math.round(avatar.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            this.$_successSave();
          } else {
            this.$_showError('Error in data saving');
          }
        }));
      } else {
        axios.all([this.saveAvatarRequest(), this.saveRequest()]).then(axios.spread((avatar, entity) => {
          if (Math.round(avatar.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            this.$_successSave();
          } else {
            this.$_showError('Error in data saving');
          }
        }));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?19977f4b